"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "migrateTableInBatches", {
    enumerable: true,
    get: function() {
        return migrateTableInBatches;
    }
});
async function migrateTableInBatches(knex, sourceTable, targetTable, transformFn, logger, options = {}) {
    const { READ_BATCH_SIZE = 1000, INSERT_BATCH_SIZE = 200, whereConditions, selectColumns = '*' } = options;
    let fetchNextBatch = true;
    const insertedIds = new Set();
    for(let offset = 0; fetchNextBatch; offset += READ_BATCH_SIZE){
        // Build the base query
        let query = knex.select(selectColumns).from(sourceTable);
        // Apply where conditions if provided
        if (whereConditions) {
            query = whereConditions(query);
        }
        const rows = await query.offset(offset).limit(READ_BATCH_SIZE + 1); // +1 to check if there are more rows
        logger.log(`Data from ${sourceTable} fetched, batch: ${offset} - ${offset + READ_BATCH_SIZE}`);
        const formattedRows = rows.slice(0, READ_BATCH_SIZE) // exclude the last row used for pagination check
        .filter((row)=>{
            if (insertedIds.has(row.id)) {
                return false;
            }
            insertedIds.add(row.id);
            return true;
        }).map(transformFn);
        if (formattedRows.length > 0) {
            await knex.batchInsert(targetTable, formattedRows, INSERT_BATCH_SIZE);
            logger.log(`Inserted ${formattedRows.length} rows from ${sourceTable} to ${targetTable}`);
        }
        // check if there are more rows to fetch
        fetchNextBatch = rows.length > READ_BATCH_SIZE;
    }
    logger.log(`Data migration from ${sourceTable} to ${targetTable} completed`);
}
